"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Assert whether the given array is empty. It is considered empty if it has no
 * elements.
 *
 * @Param {array} array = The array of which to assert if it is empty.
 *
 * @Example
 *
 *   isEmpty([])
 *   //=> true
 *
 *   isEmpty([undefined])
 *   //=> false
 *
 *   isEmpty(['pizza'])
 *   //=> false
 */
function isEmpty(array) {
    return array.length < 1;
}
exports.isEmpty = isEmpty;
//# sourceMappingURL=is-empty.js.map